import React from 'react';
import { AwardCard } from 'entities/award';
import {
    Box,
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import { useAwardsBlockState } from '../store';

export type AwardsBlockProps = GridProps & React.RefAttributes<HTMLDivElement>

export const AwardsBlock: React.FC<AwardsBlockProps> = ({
    ...props
}) => {
    const { awards } = useAwardsBlockState();

    return (
        <Grid
            background="#000000"
            {...props}
        >
            <Grid
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
                padding="2rem"
                gap="2rem"
            >
                <Grid
                    templateColumns="auto 1fr"
                    gap="2rem"
                >
                    <Text
                        fontSize="3rem"
                        fontWeight={900}
                        color="white"
                    >
                        Наши награды
                    </Text>
                    <Box
                        background="white"
                        height="3px"
                        margin="auto 0"
                    />
                </Grid>
                <Grid
                    templateColumns={{
                        base: '1fr 1fr',
                        lg: '1fr 1fr 1fr',
                    }}
                    gap="2rem"
                >
                    {awards.map(({ years, description, image }) => (
                        <AwardCard
                            years={years}
                            description={description}
                            image={image || undefined}
                        />
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};
